module.exports = __webpack_public_path__ + "img/a218_device_halo.e9b9f877.png";